module.exports = __webpack_public_path__ + "assets/process3.e16985fa.svg";